/* eslint-disable no-useless-concat */
/* eslint-disable no-debugger */
/* eslint-disable no-use-before-define */
import React, { useState, useEffect, useRef } from 'react';
import 'react-datepicker/dist/react-datepicker.css';
import '../App.css';
import { Paper, Box } from '@mui/material';
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';
import { useStateContext } from '../contexts/ContextProvider';
import Sidebar from '../components/Sidebar';
import { Navbar } from '../components';
import { variables } from '../components/Variables';
import './Homepage.css';
import FileViewPage from './FileViewPage';
import LoadingOverlay from '../components/LoadingOverlay';
import DateRangePicker from '../contexts/CustomDatePicker';
import CustomDataGrid from '../contexts/CustomDataGrid';

const Cmob1QC = () => {
  const strt = new Date(new Date(new Date().getTime()).setDate(new Date().getDate() - 1));
  const end = new Date(new Date(new Date().getTime()).setDate(new Date().getDate()));
  const [loading, setLoading] = useState(false);
  const [startDate, setStartDate] = useState(strt);
  const [endDate, setEndDate] = useState(end);
  const [tableData, setTableData] = useState([]);
  const { activeMenu, themeSettings } = useStateContext();// setChildData

  const columns = [
    { field: 'Serial',
      headerName: 'Serial',
      width: 300,
      renderCell: (params) => (
        <div style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>
          {params.value}
          {/* <div>
            <Button onClick={() => nextPageFunc(params.row.id, params.row)}>{params.value}</Button>
          </div> */}
        </div>
      ),
      valueFormatter: ({ value }) => `${(value).valueOf()}` + '\t',
      headerAlign: 'left',
      align: 'left' },
    { field: 'Executed_Date', headerName: 'Date Tested', width: 200, type: 'date', headerAlign: 'left', align: 'left' },
    { field: 'Audio_Check', headerName: 'Audio Check', width: 120, headerAlign: 'left', align: 'left' },
    { field: 'Detailed_Visual', headerName: 'Detailed Visual', width: 120, headerAlign: 'left', align: 'left' },
    { field: 'Factory_Reset', headerName: 'Factory Reset', width: 120, headerAlign: 'left', align: 'left' },
    { field: 'Functional_Test', headerName: 'Functional Test', width: 120, headerAlign: 'left', align: 'left' },
    { field: 'PIR_Quiet_Test', headerName: 'PIR Quiet Test', width: 120, headerAlign: 'left', align: 'left' },
    { field: 'Unlocking_Test', headerName: 'Unlocking Test', width: 120, headerAlign: 'left', align: 'left' },
    { field: 'Video_Check', headerName: 'Video Check', width: 120, headerAlign: 'left', align: 'left' },
    { field: 'Air_Leak_Test', headerName: 'Air Leak Test', width: 120, headerAlign: 'left', align: 'left' },
    { field: 'Pir_lens_test', headerName: 'Pir lens test', width: 120, headerAlign: 'left', align: 'left' },
  ];

  const navigate = useNavigate();
  const isMounted = useRef(false);

  useEffect(() => {
    if (!isMounted.current) {
      isMounted.current = true;
      if (localStorage.getItem('loginID')) {
        InboundrmaTable();
      }
    }
  }, []);
  useEffect(() => {
    if (startDate === null || endDate === null) {
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: 'Please Select Date!',
      });
      setStartDate(strt); // for compulsory dates
      setEndDate(end); // for compulsory dates
    }
  }, [startDate, endDate]);

  const InboundrmaTable = async () => {
    setLoading(true);
    const myHeaders = new Headers();
    myHeaders.append('Content-Type', 'application/json');
    // Thu Jan 01 1970 05:30:00 GMT+0530
    const raw = JSON.stringify({
      UserId: JSON.parse(localStorage.getItem('loginID')) === null || undefined ? null : JSON.parse(localStorage.getItem('loginID')).UserId,
      ProcessName: 'SimpliSafePortal',
      PageName: 'CMOB1 QC',
      FromDate: startDate,
      ToDate: endDate,
    });

    const requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      redirect: 'follow',
    };

    await fetch(`${variables.BASE_URL}CMOB1QC`, requestOptions)
      .then((response) => response.text())
      .then((result) => {
        if (JSON.parse(result)?.IsSuccess !== false && JSON.parse(result)?.IsAuthorize !== false) {
          setTableData(JSON.parse(result).CMOB1QC);
          // localStorage.setItem('myTabledata', result);
        } else if (JSON.parse(result)?.IsSuccess !== true && JSON.parse(result)?.IsAuthorize) {
          setTimeout(() => {
            Swal.fire({
              icon: 'error',
              title: 'Oops...',
              text: 'No Data available for this Date!',
            });
          }, 0);
          setTableData([]);
        } else if (JSON.parse(result)?.IsAuthorize !== true) {
          setTimeout(() => {
            Swal.fire({
              icon: 'error',
              title: 'Oops...',
              text: 'Access Denied!',
            });
            navigate('/');
          }, 0);
        }
        setLoading(false);
      });
  };

  // BELOW CODE FOR DATE SELECTION START TO END******
  const handleEndDateChange = (date) => {
    setEndDate(date);
    if (startDate && startDate > date) {
      setStartDate(date);
    }
  };

  const handleStartDateChange = (date) => {
    setStartDate(date);
    if (endDate && endDate < date) {
      setEndDate(date);
      document.getElementById('datePicker_idend').focus();
    }
  };
  const disableFutureDates = (date) => date.getTime() < new Date().getTime();
  return (
    <div className="flex relative dark:bg-main-dark-bg">
      {activeMenu ? (
        <div className="w-72 fixed sidebar dark:bg-secondary-dark-bg bg-white ">
          <Sidebar />
        </div>
      ) : (
        <div className="w-0 dark:bg-secondary-dark-bg">
          <Sidebar />
        </div>
      )}
      <div style={{ width: `${activeMenu ? '100%' : '100%'} `, paddingLeft: `${activeMenu ? '300px' : '0px'}` }}>
        <div className="fixed md:static bg-main-bg dark:bg-main-dark-bg navbar w-full " id="navMenu_id">
          <Navbar />
          <DateRangePicker
            loading={loading}
            startDate={startDate}
            endDate={endDate}
            handleStartDateChange={handleStartDateChange}
            handleEndDateChange={handleEndDateChange}
            disableFutureDates={disableFutureDates}
            TransferIntakeTable={InboundrmaTable}
            heading="RMA Requested Date"
          />
        </div>
        <div>
          {themeSettings}
          <div className="container-fluid">
            <div id="table_container">
              <FileViewPage />
              <Paper className="table_backpaper">
                {loading ? (
                  <LoadingOverlay />
                ) : (
                  <Box className="table_positions">
                    <CustomDataGrid
                      name="Cmob1 QC"
                      tableData={tableData}
                      column={columns}
                    />
                    <p className="dark:text-gray-500 text-gray-700 text-center " style={{ marginTop: '-30px' }}>
                      {variables.COPYRIGHT}
                    </p>
                  </Box>
                )}
              </Paper>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Cmob1QC;
